import { http } from "utils/http";

import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";

export const getPeriodInitDetail = (
  WarehouseId,
  pageNumber,
  pageSize,
  orderBy,
  searchString?: any,
  filterlist?:any,
  warehouseDetailId=null
) =>
  http({
    baseURL: INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.PeriodInit.browse,
    method: "get",
    params: {
      PageNumber: pageNumber,
      PageSize: pageSize,
      SearchString: searchString,
      OrderByString: orderBy,
      FilterString: filterlist,
      WarehouseId,
  warehouseDetailId

    },
  })
    .then((response) => response.data)
    .catch((err) => {
      return Promise.reject(err);
    });
export const removePeriodInitDetail = (removelist) =>
  http({
    baseURL: INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.PeriodInit.browse,
    method: "delete",
    data: removelist,
  })
    .then((response) => response.data)
    .catch((err) => {
      return Promise.reject(err);
    });

export const getEditablecolumns = () =>
  http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.PeriodInit
      .EditableColumnInDataGrid,
    method: "get",
  })
    .then((response) => response.data)
    .catch((err) => {
      return Promise.reject(err);
    });

export const postBatchAddApi = (data) =>
  http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.PeriodInit.BatchAdd,
    method: 'post',
    data: data,
  })
    .then((response) => response.data)
    .catch((err) => {
      return Promise.reject(err);
    });
    export const putBatchEditApi = (data) =>
  http({
    baseURL: INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.PeriodInit.BatchEdit,
    method: 'put',
    data: data,
  })
    .then((response) => response.data)
    .catch((err) => {
      return Promise.reject(err);
    });

export const postEditableColumn = (data, method) =>
  http({
    baseURL: INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.PeriodInit.browse,
    method: method,
    data,
  })
    .then((response) => response.data)
    .catch((err) => {
      return Promise.reject(err);
    });
export const importPeriodInit = (data,warehouseId , warehouseDetailId
) => http({
    baseURL:INVENTORYANDSALES_URL,
    url : ENDPOINTSINVENTORYANDSALES.Inventory.PeriodInit.import,
    method: 'post',
    data: data,
    params:{
    warehouseId,
    warehouseDetailId

    },
    headers: {
        "content-type": "multipart/form-data",
    }
}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject(err);
})
export const postTransfer = (warehouseId,warehouseDetailId,isRegisteredByPrice,isRegisteredByQuantity) =>
  http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.PeriodInit.Transfer,
    method: 'post',
   params:{
    warehouseId,warehouseDetailId,isRegisteredByPrice,isRegisteredByQuantity
   }
  })
    .then((response) => response.data)
    .catch((err) => {
      return Promise.reject(err);
    });